import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ShowView = 'asFound' | 'all' | 'asLeft';

interface CalibrationUIState {
  touchModeEnabled: boolean;
  showView: ShowView;
  setTouchModeEnabled: (enabled: boolean) => void;
  setShowView: (view: ShowView) => void;
  resetToDefaults: () => void;
}

const isMobileOrTablet = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(max-width: 1450px)').matches;
};

const getDefaultState = () => ({
  touchModeEnabled: isMobileOrTablet(),
  showView: 'all' as ShowView
});

export const useCalibrationUIStore = create<CalibrationUIState>()(
  persist(
    set => ({
      ...getDefaultState(),

      setTouchModeEnabled: (enabled: boolean) =>
        set({ touchModeEnabled: enabled }),

      setShowView: (view: ShowView) => set({ showView: view }),

      resetToDefaults: () => set(getDefaultState())
    }),
    {
      name: 'calibration-ui-preferences',
      partialize: state => ({
        touchModeEnabled: state.touchModeEnabled,
        showView: state.showView
      })
    }
  )
);

export const useTouchModeEnabled = () =>
  useCalibrationUIStore(state => state.touchModeEnabled);

export const useShowView = () => useCalibrationUIStore(state => state.showView);
